import React, { Component } from 'react';
import BioPhoto from './BioPhoto';
import MemberQRCard from './MemberQRCard';
import MemberTestRecords from './MemberTestRecords';
import zaidena from '../assets/zaidena.png';
import sattahip from '../assets/sattahip.png';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Bio.css';

class BioZaidena extends Component {
  state = {
    user: null,
    loading: true,
    error: '',
  };

  async componentDidMount() {
    try {
      const email = localStorage.getItem('email');

      if (!email) {
        throw new Error('No email found. Please login again.');
      }

      const res = await fetch(`/user-details?email=${encodeURIComponent(email)}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to fetch user data');
      }

      this.setState({
        user: {
          email: data.email,
          balance: data.balance,
          name: 'MR. ZAIDEN ANDERSSON',
          dojo: 'MARINE MARTIAL ARTS DOJO, CHONBURI, THAILAND',
          rank: '8 KYU',
          rankDate: '27/09/26',
          membershipNumber: '8044',
          membershipExpiry: '12/2026',
          nationality: 'PHILIPPINE',
        },
        loading: false,
      });
    } catch (err) {
      this.setState({
        error: err.message,
        loading: false,
      });
    }
  }

  renderUserInfo() {
    const { user } = this.state;

    return (
      <div style={{ marginBottom: '20px' }}>
        <div><strong>Email:</strong> {user.email}</div>
        <div><strong>Balance:</strong> {user.balance}</div>
      </div>
    );
  }

  renderRank() {
    const { user } = this.state;

    if (!user) return '8 KYU (27/09/26)';

    return user.rankDate
      ? `${user.rank} (${user.rankDate})`
      : user.rank;
  }

  render() {
    const { user, loading, error } = this.state;

    return (
      <div className="BioZaidena">

     <img
       className="top-logo"
       src={logo}
        alt="App Logo"
      />


        <h1>Member's Biography</h1>

        {loading && <div>Loading user data...</div>}

        {error && (
          <div style={{ color: 'red', marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {user && this.renderUserInfo()}

        <BioPhoto
          slug="zaidena"
          fallback={zaidena}
          className="zaidena"
          alt="Zaiden Andersson"
        />

        <h2>{user ? user.name : 'MR. ZAIDEN ANDERSSON'}</h2>

        <img
          className="sattahip"
          src={sattahip}
          alt="Marine Martial Arts Dojo"
        />

        <br />
        <br />

        <div>
          DOJO : {user ? user.dojo : 'MARINE MARTIAL ARTS DOJO, CHONBURI, THAILAND'}
        </div>

        <div>
          CURRENT RANK : {this.renderRank()}
        </div>

        <div>
          AAT MEMBERSHIP NUMBER : {user ? `${user.membershipNumber} (Expired : ${user.membershipExpiry})` : '8044 (Expired : 12/2026)'}
        </div>

        <div>
          DATE OF BIRTH : N/A
        </div>

        <div>
          NATIONALITY : {user ? user.nationality : 'PHILIPPINE'}
        </div>

        <br />

        <MemberTestRecords slug="zaidena" />

        <br />

        <MemberQRCard slug="zaidena" />

        <br />

        <div>Powered by</div>

        <img
          className="logo2"
          src={logo2}
          alt="New Wave Consulting Group logo"
        />

        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default BioZaidena;
